import React from 'react'
import Image from 'next/image'

function Banner({ bannerData }: { bannerData: Banner }) {
    return (
        <a href={bannerData.redirect_url}>
            {bannerData.image ? (
                <Image
                    style={{
                        height: '100%',
                        width: '100%',
                        borderRadius: '8px',
                    }}
                    src={bannerData?.image}
                    width={1000}
                    height={500}
                    alt={bannerData?.body || 'Banner'}
                />
            ) : null}
        </a>
    )
}

export default Banner
